<template>
  <div class="claims-page">
    <el-card shadow="never">
      <div class="toolbar">
        <el-form v-if="level === 1" :inline="true" size="small">
          <el-form-item label="自定义检索">
            <el-select value="按险种" disabled class="search-type">
              <el-option label="按险种" value="按险种" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="riskType" placeholder="请选择险种">
              <el-option label="货运险" :value="1" />
              <el-option label="员工险" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search">搜索</el-button>
            <el-button @click="showAll">重置</el-button>
          </el-form-item>
        </el-form>
        <span v-else />
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openDialog()"
        >
          添加事故原因{{ levelText }}
        </el-button>
      </div>

      <el-table v-loading="loading" :data="rows" border stripe>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="openDialog(scope.row)">
              编辑
            </el-button>
            <el-button
              v-if="level < 3"
              type="text"
              @click="openChildren(scope.row)"
            >
              事故原因{{ nextLevelText }}
            </el-button>
            <el-button type="text" @click="toggle(scope.row)">
              {{ scope.row.disabled ? "启用" : "禁用" }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="险种" width="170" align="center">
          <template slot-scope="scope">
            {{ riskLabels[scope.row.risk_type] || "" }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="level >= 2"
          prop="level_one_name"
          label="事故原因一级"
          min-width="170"
          align="center"
        />
        <el-table-column
          v-if="level === 3"
          prop="level_two_name"
          label="事故原因二级"
          min-width="170"
          align="center"
        />
        <el-table-column
          prop="name"
          :label="level === 1 ? '名称' : `事故原因${levelText}`"
          min-width="170"
          align="center"
        />
        <el-table-column
          prop="created_at"
          label="创建时间"
          width="190"
          align="center"
          :formatter="dateFormatter"
        />
        <el-table-column
          prop="updated_at"
          label="更新时间"
          width="190"
          align="center"
          :formatter="dateFormatter"
        />
      </el-table>

      <el-pagination
        class="pagination"
        :current-page="page"
        :page-size="pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        :page-sizes="[10, 15, 20, 25]"
        @current-change="changePage"
        @size-change="changeSize"
      />
    </el-card>

    <el-dialog
      :title="
        `${form.id ? '编辑' : '添加'}事故原因${level === 1 ? '' : levelText}`
      "
      :visible.sync="visible"
      width="460px"
    >
      <el-form
        ref="form"
        v-loading="formLoading"
        :model="form"
        :rules="rules"
        label-width="130px"
      >
        <el-form-item label="险种" prop="risk_type">
          <el-select v-model="form.risk_type" :disabled="level > 1">
            <el-option label="货运险" :value="1" />
            <el-option label="员工险" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="level >= 2" label="事故原因一级">
          <el-input v-model="form.level_one_name" disabled />
        </el-form-item>
        <el-form-item v-if="level === 3" label="事故原因二级">
          <el-input v-model="form.level_two_name" disabled />
        </el-form-item>
        <el-form-item
          :label="level === 1 ? '名称' : `事故原因${levelText}`"
          prop="name"
        >
          <el-input v-model.trim="form.name" maxlength="64" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getReasons,
  getReasonInfo,
  saveReason,
  setReasonDisabled
} from "@/api/claims-management";
import { formatDateTime } from "../constants";

const LEVEL_KEYS = { 1: "levelone", 2: "leveltwo", 3: "levelthree" };
const LEVEL_TEXT = { 1: "一级", 2: "二级", 3: "三级" };

export default {
  name: "ClaimReasonList",
  props: {
    level: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      riskLabels: { 1: "货运险", 2: "员工险" },
      riskType: 1,
      queryRiskType: "",
      loading: false,
      rows: [],
      total: 0,
      page: 1,
      pageSize: 15,
      visible: false,
      formLoading: false,
      saving: false,
      form: this.emptyForm(),
      rules: {
        risk_type: [
          { required: true, message: "请选择险种", trigger: "change" }
        ],
        name: [{ required: true, message: "请输入事故原因", trigger: "blur" }]
      }
    };
  },
  computed: {
    levelText() {
      return LEVEL_TEXT[this.level];
    },
    nextLevelText() {
      return LEVEL_TEXT[this.level + 1];
    },
    parentId() {
      return Number(this.$route.query.parent_id || 0);
    }
  },
  watch: {
    "$route.query.parent_id"() {
      this.page = 1;
      this.fetchList();
    }
  },
  created() {
    this.fetchList();
  },
  methods: {
    emptyForm() {
      return {
        id: null,
        parent_id: null,
        risk_type: 1,
        level_one_name: "",
        level_two_name: "",
        name: ""
      };
    },
    async fetchList() {
      if (this.level > 1 && !this.parentId) {
        this.rows = [];
        this.total = 0;
        return;
      }
      this.loading = true;
      try {
        const params = { page: this.page, rows: this.pageSize };
        if (this.level === 1 && this.queryRiskType) {
          params.risk_type = this.queryRiskType;
        }
        if (this.level > 1) params.parent_id = this.parentId;
        const res = await getReasons(LEVEL_KEYS[this.level], params);
        this.rows = res.rows || [];
        this.total = Number(res.total || this.rows.length);
      } finally {
        this.loading = false;
      }
    },
    search() {
      this.queryRiskType = this.riskType;
      this.page = 1;
      this.fetchList();
    },
    showAll() {
      this.riskType = "";
      this.queryRiskType = "";
      this.page = 1;
      this.fetchList();
    },
    openChildren(row) {
      const routeNames = {
        1: "claimAccidentReasonLevelTwo",
        2: "claimAccidentReasonLevelThree"
      };
      this.$router.push({
        name: routeNames[this.level],
        query: {
          parent_id: row.id,
          parent_name: row.name
        }
      });
    },
    async openDialog(row) {
      this.form = this.emptyForm();
      this.form.id = row ? Number(row.id) : null;
      this.form.parent_id = this.level > 1 ? this.parentId : null;
      this.visible = true;
      this.formLoading = true;
      try {
        if (row) {
          const res = await getReasonInfo({ id: row.id });
          this.applyReasonInfo(res.data || {});
        } else if (this.level > 1) {
          const res = await getReasonInfo({ id: this.parentId });
          this.applyParentInfo(res.data || {});
        }
      } finally {
        this.formLoading = false;
        this.$nextTick(
          () => this.$refs.form && this.$refs.form.clearValidate()
        );
      }
    },
    applyReasonInfo(info) {
      this.form = {
        ...this.form,
        id: Number(info.id),
        parent_id: info.parent_id ? Number(info.parent_id) : null,
        risk_type: Number(info.risk_type),
        level_one_name: info.level_one_name || "",
        level_two_name: info.level_two_name || "",
        name: info.name || ""
      };
    },
    applyParentInfo(info) {
      this.form.risk_type = Number(info.risk_type);
      if (this.level === 2) {
        this.form.level_one_name = info.name || "";
      } else {
        this.form.level_one_name = info.level_one_name || "";
        this.form.level_two_name = info.name || "";
      }
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (!valid) return;
        this.saving = true;
        try {
          const data = {
            level: this.level,
            risk_type: Number(this.form.risk_type),
            name: this.form.name
          };
          if (this.form.id) data.id = Number(this.form.id);
          if (this.level > 1 && !this.form.id) {
            data.parent_id = Number(this.parentId);
          }
          await saveReason(data);
          this.$message.success("保存成功");
          this.visible = false;
          this.fetchList();
        } finally {
          this.saving = false;
        }
      });
    },
    toggle(row) {
      this.$confirm(`您确认想要修改 ${row.name} 的状态吗？`, "确认", {
        type: "warning"
      })
        .then(async () => {
          await setReasonDisabled({
            id: Number(row.id),
            disabled: !row.disabled
          });
          this.$message.success("修改成功");
          this.fetchList();
        })
        .catch(() => {});
    },
    dateFormatter(row, column, value) {
      const result = formatDateTime(value);
      return result === "-" ? "" : result;
    },
    changePage(value) {
      this.page = value;
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.page = 1;
      this.fetchList();
    }
  }
};
</script>

<style scoped>
.claims-page {
  padding: 20px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.search-type {
  width: 130px;
}
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>
